export { default } from './sliderSwiper'
